import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconCaretUpDown12 from './IconCaretUpDown12';
import IconCaretUpDown16 from './IconCaretUpDown16';
import IconCaretUpDown20 from './IconCaretUpDown20';
import IconCaretUpDown24 from './IconCaretUpDown24';
import IconCaretUpDown32 from './IconCaretUpDown32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconCaretUpDown = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconCaretUpDown12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconCaretUpDown16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconCaretUpDown20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconCaretUpDown24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconCaretUpDown32 {...props} />}
        </span>
    );
};
IconCaretUpDown.displayName = 'FondueIconCaretUpDown';

export default memo(IconCaretUpDown);
